import type { Client } from '@/types';

/** The chosen clients in a few words: "All clients (142)", "acme" or "12 clients". */
export function getSelectionDisplayText(clients: Client[], selectedClientNames: string[]): string {
  if (selectedClientNames.length === 0) return 'No clients';
  if (selectedClientNames.length === clients.length) return `All clients (${clients.length})`;
  if (selectedClientNames.length === 1) return selectedClientNames[0];
  return `${selectedClientNames.length} clients`;
}

/** A count with its noun: "1 client", "12 clients", "1,204 users". */
export function countOf(n: number, word: string): string {
  return `${n.toLocaleString()} ${word}${n === 1 ? '' : 's'}`;
}

/** Why something failed, ended with a full stop so a sentence can follow it. */
export function reasonOf(error: unknown): string {
  const text = (error instanceof Error ? error.message : typeof error === 'string' ? error : '').trim();
  if (!text) return 'No reason was given.';
  return /[.!?]$/.test(text) ? text : `${text}.`;
}
